import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import * as locales from './locales/index'
import { setLocalLanguage } from 'helpers/localstorage.helpers'
import { LANGUAGES } from 'constants/index'

const DEFAULT_LANGUAGE = LANGUAGES[0].languageCode
const AVAILABLE_LANGUAGE_CODES = Object.keys(locales)

const getLanguageFromUrl = () => {
  if (typeof window === 'undefined') return null
  const lang = new URLSearchParams(window.location.search).get('lang')
  if (!lang) return null
  const normalized = String(lang).toLowerCase()
  return AVAILABLE_LANGUAGE_CODES.includes(normalized) ? normalized : null
}

const urlLang = getLanguageFromUrl()
const initialLanguage = urlLang || DEFAULT_LANGUAGE

if (urlLang) {
  setLocalLanguage(urlLang)
}

i18n.use(initReactI18next).init({
  resources: {
    ...Object.entries(locales).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: {
          translation: value
        }
      }),
      {}
    )
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false
  }
})

export default i18n
